<template>
<div>
  <b-card>
  <h4 class="text-center text-uppercase">Entrega de pedido</h4>
  <p><strong>Nombre:</strong>{{user.name}}</p><strong>Code:</strong>{{user.code}}
  </b-card>
  <b-container fluid>
  <b-row>
    <b-col cols='3' v-for="producto in products" :key="producto.id">
      <b-card :border-variant="producto.complete === '2'? 'info' : 'danger' " :header="tittle + producto.turn" header-text-variant="white" :header-border-variant="producto.complete === '2'? 'info' : 'danger'" :header-bg-variant="producto.complete === '2'? 'info' : 'danger'" :title="producto.products" align="center">
      <div class="text-left">
        <p> <strong>Cantidad:</strong> {{producto.count}}</p>
        <p><strong>Total:</strong> {{producto.total}}</p>
      </div>
          <b-button class="pull-right" size='lg'  :variant="producto.complete === '2' ? 'success' : 'danger'" :disabled='producto.complete === "2" ? false : true' @click='dispatchProduct(producto)'>Entregar</b-button>
      </b-card>
    </b-col>
  </b-row>
  </b-container>
</div>
</template>
<script>
export default {
  name: 'dispatch',
  data () {
    return {
      user: '',
      products: [],
      tittle: 'Turno No. '
    }
  },
  created () {
    this.user = this.$store.getters.cafeteriaRequestsExt.user
    this.getRequest()
  },
  methods: {
    getRequest () {
      this.$store.dispatch('getRequestFromUser', this.user.id_user_primary).then((response) => {
        this.products = this.$store.getters.cafeteriaRequestsExt.products
      }).catch((error) => {
        console.log('Error ', error)
      })
    },
    dispatchProduct (item) {
      this.$store.dispatch('externalDispatchProduct', item).then((response) => {
        this.products.forEach(element => {
          if (element.id === item.id) {
            // console.log(this.products.indexOf(element,1))
            this.products.splice(this.products.indexOf(element), 1)
          }
        })
      }).catch((error) => {
        console.log('error ', error)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/external/entrega/index.vue